const theme = {
  color: {
    primary: '#000000',
    secondary: '#CCCCCC',
    action: '#3E9F48',
    actionHover: '#0000CC',
    text: '#000000',
    textLight: '#777777',
    disabled: '#CCCCCC',
    whiteOffset: '#EEEEEE',
    grayLighter: '#CCCCCC',
  },
  font: {
    sansSerif: '"Source Sans Pro", sans-serif',
    serif: '"Source Serif Pro", serif',
    mono: '"Source Code Pro", monospace',
  },
  text: {
    fontSize: 18,
    lineHeight: 24,
  },
  button: {
    borderRadius: 3,
  },
  screen: {

  },
  section: {

  },
  padding: {
    small: 5,
    base: 10,
    large: 20,
  },
};

export default theme;



// WEBPACK FOOTER //
// ./src/common/theme.js